import { render, staticRenderFns } from "./Others.vue?vue&type=template&id=24c601be&"
import script from "./Others.vue?vue&type=script&lang=js&"
export * from "./Others.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports